import React, { FC } from 'react'

import { WebinarPage } from '../../../../components/library/webinars/WebinarPage'

const WebinarPageRoute: FC = () => {
  return <WebinarPage />
}

export default WebinarPageRoute
